
export const HEADER_HEIGHT = 64;
export const COLORS = {
  PRIMARY: '#0055ff',
  TEXT: '#172b4d'
}

export const BORDER = '1px solid rgba(0, 85, 255, 0.24)'
